<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-9">
        <article class="entry single">
          <div class="entry-media" v-if="blog.imageUrl">
            <router-link :to="{ name: 'Blog', params: { id: blog.id } }">
              <img
                :src="`${baseUrl}${blog.imageUrl}`"
                alt="Post image"
              />
            </router-link>
          </div>
          <!-- End .entry-media -->
          <div class="entry-body">
            <div class="entry-date" v-if="blog && blog.createdDate">
              <span class="day">{{ formatDate(blog.createdDate, 'dd') }}</span>
              <span class="month">{{ formatDate(blog.createdDate, 'MMM') }}</span>
            </div>
            <!-- End .entry-date -->
            <h2 class="entry-title">{{ blog.title }}</h2>
            <div class="entry-meta" v-if="blog && blog.createdDate">
              <span><i class="icon-calendar"></i>
                {{ formatDate(blog.createdDate, 'MMMM dd, yyyy') }}
              </span>
            </div>
            <!-- End .entry-meta -->
            <div class="entry-content list-styles">
              <div class="html-content" v-html="blog.description">
              </div>
            </div>
            <!-- End .entry-content -->
            <!-- <div class="entry-share">
              <h3>
                <i class="icon-forward"></i>
                Podijeli ovu vijest
              </h3>
              <div class="social-icons">
                <a
                  href="#"
                  class="social-icon social-facebook"
                  target="_blank"
                  title="Facebook"
                >
                  <i class="fab fa-facebook-f"></i>
                </a>
                <a
                  href="#"
                  class="social-icon social-twitter"
                  target="_blank"
                  title="Twitter"
                >
                  <i class="fab fa-twitter"></i>
                </a>
                <a
                  href="#"
                  class="social-icon social-linkedin"
                  target="_blank"
                  title="Linkedin"
                >
                  <i class="fab fa-linkedin-in"></i>
                </a>

                <a
                  href="#"
                  class="social-icon social-mail"
                  target="_blank"
                  title="Email"
                >
                  <i class="icon-mail-alt"></i>
                </a>
              </div> -->
              <!-- End .social-icons -->
            <!-- </div> -->
            <!-- End .entry-share -->
          </div>
          <!-- End .entry-body -->
        </article>
        <!-- End .entry -->
      </div>
      <!-- End .col-lg-9 -->
      <aside class="sidebar col-lg-3">
        <div class="sidebar-wrapper">
          <!-- <div class="widget widget-search">
            <form role="search" method="get" class="search-form" action="#">
              <input
                type="search"
                class="form-control"
                placeholder="Pretraži vijesti..."
                name="s"
                required
              />
              <button type="submit" class="search-submit" title="Search">
                <i class="icon-search"></i>
                <span class="sr-only">Search</span>
              </button>
            </form>
          </div> -->
          <!-- End .widget -->
          <div class="widget">
            <h4 class="widget-title">{{ translations.recentBlogs }}</h4>
            <ul class="simple-entry-list">
              <li v-for="item in recentBlogs" :key="item.id">
                <div class="entry-media" v-if="item.imageUrl">
                  <router-link :to="{ name: 'Blog', params: { id: item.id } }">
                  <img
                    :src="`${baseUrl}${item.imageUrl}`"
                    alt="Post"
                  />
                  </router-link>
                </div>
                <!-- End .entry-media -->
                <div class="entry-info">
                  <router-link :to="{ name: 'Blog', params: { id: item.id } }">
                    {{ item.title }}
                  </router-link>
                  <div class="entry-meta">{{ formatDate(item.createdDate, 'MMMM dd, yyyy') }}</div>
                  <!-- End .entry-meta -->
                </div>
                <!-- End .entry-info -->
              </li>
            </ul>
          </div>
          <!-- End .widget -->
          <!-- <div class="widget">
            <h4 class="widget-title">Tagovi</h4>
            <div class="tagcloud">
              <a href="#">Kuhinja</a>
              <a href="#">Hoteli</a>
              <a href="#">Restorani</a>
              <a href="#">Podovi</a>
              <a href="#">Čistoća</a>
            </div>
          </div> -->
          <!-- End .widget -->
          <!-- <div class="widget">
            <h4 class="widget-title">Arhiva</h4>
            <ul class="list">
              <li><a href="#">April 2018</a></li>
              <li><a href="#">March 2018</a></li>
              <li><a href="#">February 2018</a></li>
            </ul>
          </div> -->
          <!-- End .widget -->
        </div>
        <!-- End .sidebar-wrapper -->
      </aside>
      <!-- End .col-lg-3 -->
    </div>
  </div>
</template>

<script>
import helpers from '@/services/helpers';
import config from '@/config';
import translations from '@/mixins/translations';

export default {
  name: 'Blog',
  mixins: [translations],
  computed: {
    baseUrl() {
      return config.baseUrl;
    },
    blog() {
      return this.$store.getters.getBlog;
    },
    recentBlogs() {
      return this.$store.getters.getRecentBlogs;
    },
  },
  methods: {
    formatDate: helpers.formatDate,
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.$store.dispatch('getBlog', this.$route.params.id);
    this.$store.dispatch('getRecentBlogs');
  },
};
</script>

<style>
.list-styles ul,
.list-styles ol {
  list-style: initial;
  padding-left: 20px;
}
.list-styles li {
  margin-bottom: 5px;
}

.entry-content img {
  max-width: 100%;
  height: auto;
  display: block;
}

.html-content a {
  color: #3598DB;
}
</style>
